import React from 'react'
import { visitDashboardConstants } from '../constants/Constants'
import styles from '../listOfCamps.module.scss'

export function campReportCellRenderer(params: any): JSX.Element {
  const campId = params?.data?.campId

  if (!campId) {
    return <span className={styles.campTableViewReportEmpty}>-</span>
  }

  const handleViewReportClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e?.preventDefault()
    const cb = params?.context?.onPreviewReport
    if (typeof cb === visitDashboardConstants?.defaults?.function && campId) {
      try {
        cb(campId)
      } catch {
        // swallow errors from consumer to keep renderer safe
      }
    }
  }

  return (
    <a
      href='#'
      className={styles.campTableViewReport}
      aria-label='View Report'
      onClick={handleViewReportClick}
    >
      View
    </a>
  )
}

export default campReportCellRenderer
